import { Term } from "@/components/Term";

// Research-table header → glossary key. Matched case-insensitively on the header's start so variants like "Accuracy (95% CI)" resolve.
const MAP = [
  ["accuracy (95% ci", "stat_ci"], ["accuracy", "stat_accuracy"], ["sign-after-cost", "stat_sac"], ["observed profitable", "stat_sac"],
  ["95% ci", "stat_ci"], ["observed (ci)", "stat_ci"], ["pf", "stat_pf"], ["max dd", "stat_maxdd"], ["exposure", "stat_exposure"], ["cum. net", "stat_cum_net"],
  ["avg net", "stat_cum_net"], ["reserved", "stat_out_of_sample"], ["development", "stat_out_of_sample"], ["calibrated", "stat_platt"], ["observed hit rate", "stat_accuracy"],
  ["graded", "ledger_status"], ["brier", "stat_brier"], ["ece", "stat_ece"], ["reliability", "stat_reliability"],
];
export const statKey = (h) => { const x = String(h || "").toLowerCase(); return (MAP.find(([p]) => x.startsWith(p)) || [])[1] || null; };

// Table header cell content with an ⓘ when the term has a glossary entry.
export const StatTh = ({ h }) => { const k = statKey(h); return k ? <Term k={k} side="bottom" iconClass="normal-case">{h}</Term> : h; };
